import { connect } from 'react-redux'
import * as action from '../../state/list/action'
import * as anamnesisAction from '../../state/anamnesis/action'
import * as selector from '../../state/list/selector'
import AnamnesisList from './AnamnesisList'
import { isIPRProviderStore } from '../../../globals/state/selector'
import { selectUserStore } from '../../../security/state/auth/selector'

const mapStateToProps = (state, { customer }) => {
    return {
        customerId: customer.id,
        anamnesisList: selector.selectAnamnesisList(state),
        isIPRProviderStore: isIPRProviderStore(state, customer.store),
        isUserFromCustomerStore: selectUserStore(state) === customer.store,
        showAnamnesis: selector.selectShowAnamnesis(state),
        isInfoLegendShown: selector.selectShowInfoLegendShown(state),
    }
}

const mapDispatchToProps = {
    findByCustomerId: action.findByCustomerId,
    toggleAnamnesis: action.toggleAnamnesis,
    toggleInfoLegend: action.toggleInfoLegend,
    changeAnamnesis: anamnesisAction.changeAnamnesis,
    saveAnamnesis: anamnesisAction.saveAnamnesis,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnamnesisList)



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/list/AnamnesisListContainer.js